module.exports = new __parcel__URL__("janeckova.cbcb6cdd.jpg").toString();